import React from 'react'
import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';
import Home from './components/home/Home';
import Hero from './components/hero/Hero2';


function App() {
  return (
    <>

      <Navbar />
      <Hero />
      <Home />
      <Footer />
    </>
  );
}

export default App;
